/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconChair/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconChair({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconChair",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconChair.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-lXWVr': alignSelf,'--mt-2-lXWVr': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-lXWVr': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-lXWVr': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-lXWVr': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-lXWVr': opacity,'--w-10-lXWVr': typeof width === 'number' ? `${width}px` : width,'--h-11-lXWVr': typeof height === 'number' ? `${height}px` : height,'--a-7-lXWVr': isAnimated ? animation : "none",'--sd-8-lXWVr': isAnimated ? strokeDashoffset : 0,'--sd-9-lXWVr': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconChair.SvgPath"
  data-view-path={viewPath}
 d="M20 8V6c0-1.65-1.35-3-3-3H7C5.35 3 4 4.35 4 6v2c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3v1c0 .55.45 1 1 1s1-.45 1-1v-1h12v1c0 .55.45 1 1 1s1-.45 1-1v-1c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3zM6 6c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v2.78c-.61.55-1 1.34-1 2.22v2H7v-2c0-.88-.39-1.67-1-2.22V6zm15 10c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v4h14v-4c0-.55.45-1 1-1s1 .45 1 1v5z"
 style={{'--f-12-lXWVr': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}